<template>
    <div class="p-3">
        <img-comparison-slider class="img-comparison-slider br-4 shadow">
            <figure slot="first" class="before">
                <img width="100%" :src="firstImage" :alt="'Before' | trans" />
            </figure>
            <figure slot="second" class="after">
                <img width="100%" :src="secondImage" :alt="'After' | trans" />
            </figure>
        </img-comparison-slider>
    </div>
</template>
<style>
.img-comparison-slider:focus {
    outline: none;
}

.before,
.after {
    margin: 0;
}
</style>

<script>
import TransFilter from './mixins/TransFilter';

export default {
    name: 'ColorizeImageSlider',
    mixins: [TransFilter],
    mounted() {},
    props: {
        firstImage: {
            type: String,
            required: true,
        },
        secondImage: {
            type: String,
            required: true,
        },
    },
    methods: {},
    data() {
        return {};
    },
};
</script>
